import { combineReducers } from 'redux'
import registration from './registrations'
import userMessage from './userMessage'

export default combineReducers({
  registration,
  userMessage,
})